var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({staticClass:"relative",attrs:{"id":"menu-container"}},'div',_vm.$attrs,false),[_vm._t("default"),_vm._v(" "),(_vm.open)?_c('div',{staticClass:"dropdown"},[_vm._t("menuContent")],2):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }